module.exports = __webpack_public_path__ + "media/images/web/home/index/specs/exhibitors-a1607c3ac2d0dfd58a9ed5fc27f33434.svg";